import axios from 'axios'
import decode from 'jwt-decode'

import { getAuthentication, removeSecurityToken, saveSecurityToken } from '../../security/securityContext'

import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { AUTHENTICATION_FAILED, USER_AUTHENTICATED, AUTENTICATION_TWO_FACTORY, REENVIAR_CODIGO_AUTENTICACAO_DOIS_FATORES, USER_LOGOUT } from '../types'
import { URL } from '../../util/ambienteActions';

const authenticationUrl = `${URL}/auth/signin`
const confirmarAutenticacaoDoisFatoresUrl = `${URL}/auth/confirmar-autenticacao-dois-fatores`
const reenviarCodigoAutenticacaoDoisFatoresUrl = `${URL}/auth/reenviar-codigo-autenticacao-dois-fatores`

export function validarToken (token) {
  const dataToken = decode(token).exp;
  // eslint-disable-next-line radix
  const dataCorrente = parseInt(Date.now() / 1000);
  return dataToken > dataCorrente
}

export function isUserAuthenticated (auth) {
  return auth && auth.isAuthenticated && auth.tokenJwt && validarToken(auth.tokenJwt)
}

export function ordenarEmpresas (empresas) {
  return empresas.sort((n1, n2) => {
    if (n1.nome > n2.nome) {
      return 1;
    }

    if (n1.nome < n2.nome) {
      return -1;
    }

    return 0;
  })
}

export const authenticateUser = data => dispatch => axios.post(authenticationUrl, data, SLOW_REQUEST_CONFIG)
  .then((response) => {
    const usuarioAutenticado = response.data
    
    const empresasOrdenadas = ordenarEmpresas(usuarioAutenticado.empresas);

    if (usuarioAutenticado.habilitadoAutenticacaoDoisFatores) {      
      const authentication = {
        habilitadoAutenticacaoDoisFatores: usuarioAutenticado.habilitadoAutenticacaoDoisFatores,
        habilitadoAceiteAutenticacaoDoisFatores: usuarioAutenticado.habilitadoAceiteAutenticacaoDoisFatores,
        hashAutenticaoDoisFatores: usuarioAutenticado.hashAutenticaoDoisFatores,
        validadeAutenticacaoDoisFatores: usuarioAutenticado.validadeAutenticacaoDoisFatores,
        dataRecusaAutenticacaoDoisFatores: usuarioAutenticado.dataRecusaAutenticacaoDoisFatores,
        tokenJwt: null,
        username: data.username,
        nomeUsuario: null,        
        nomeUsuarioComNumero: null,        
        idUsuario: null,
        empresas: empresasOrdenadas,
        roles: usuarioAutenticado.tokenServico.roles,
        empresasSelecao: empresasOrdenadas,
        isAuthenticated: false
      };

      saveSecurityToken(authentication)
      
      return dispatch({
        type: AUTENTICATION_TWO_FACTORY,
        payload: authentication
      })
    } else {
      const tokenDecodificado = decode(usuarioAutenticado.tokenServico.tokenJwt)
      
      if (!validarToken(usuarioAutenticado.tokenServico.tokenJwt)) {
        dispatch({
          type: AUTHENTICATION_FAILED,
          payload: { erro: 'Sessão Expirou' }
        })
      }
      const authentication = {
        habilitadoAceiteAutenticacaoDoisFatores: usuarioAutenticado.habilitadoAceiteAutenticacaoDoisFatores,
        habilitadoAutenticacaoDoisFatores: usuarioAutenticado.habilitadoAutenticacaoDoisFatores,
        hashAutenticaoDoisFatores: null,
        dataRecusaAutenticacaoDoisFatores: usuarioAutenticado.dataRecusaAutenticacaoDoisFatores,
        tokenJwt: usuarioAutenticado.tokenServico.tokenJwt,
        username: data.username,
        nomeUsuario: tokenDecodificado.nus,
        nomeUsuarioComNumero: tokenDecodificado.nomeUsuarioComNumero,
        idUsuario: tokenDecodificado.codigoUsuario,
        empresas: empresasOrdenadas,
        roles: usuarioAutenticado.tokenServico.roles,
        empresasSelecao: empresasOrdenadas,
        isAuthenticated: true
      };
      saveSecurityToken(authentication)

      return dispatch({
        type: USER_AUTHENTICATED,
        payload: authentication
      })
    }
  })
  .catch(err => dispatch({
    type: AUTHENTICATION_FAILED,
    payload: { err }
  }))

export const logoutUser = () => {
  removeSecurityToken()
  return {
    type: USER_LOGOUT,
    payload: {
      tokenJwt: null,
      isAuthenticated: false,
      username: null
    }
  }
}

export const confirmarAutenticacaoDoisFatores = data => dispatch => axios.post(confirmarAutenticacaoDoisFatoresUrl, data, SLOW_REQUEST_CONFIG)
.then((response) => {
  const usuarioAutenticado = response.data
  const tokenDecodificado = decode(usuarioAutenticado.tokenServico.tokenJwt)
  if (!validarToken(usuarioAutenticado.tokenServico.tokenJwt)) {
    dispatch({
      type: AUTHENTICATION_FAILED,
      payload: { erro: 'Sessão Expirou' }
    })
  }

   let authentication = getAuthentication();
   authentication = Object.assign({}, authentication, { 
    tokenJwt: usuarioAutenticado.tokenServico.tokenJwt, 
    nomeUsuario: tokenDecodificado.nus,    
    nomeUsuarioComNumero: tokenDecodificado.nomeUsuarioComNumero,    
    idUsuario: tokenDecodificado.codigoUsuario,    
    isAuthenticated: true 
  });

  saveSecurityToken(authentication)

  return dispatch({
    type: USER_AUTHENTICATED,
    payload: authentication
  })

});

export  const reenviarCodigoAutenticacaoDoisFatores = (data) => {  
  return dispatch => axios.post(reenviarCodigoAutenticacaoDoisFatoresUrl, data, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
          type: REENVIAR_CODIGO_AUTENTICACAO_DOIS_FATORES,
          payload: response
      })
  );
}